import {
	PURCHASE_INDENTS_LIST,
	PURCHASE_INDENTS_LIST_SUCCESS,
	ALL_PURCHASE_INDENTS_LIST_CHECKED,
	PURCHASE_INDENTS_LIST_CHECKED,
	RFQ_SELECTED_ITEM,
	RFQ_SELECTED_ALL_VENDORS,
	RFQ_SELECTED_VENDORS,
	CELAR_VENDORS,
	VENDORS_LIST,
	VENDORS_LIST_SUCCESS,
	GET_VENDORS_DATA,
	VENDORS_DATA_SUCCESS,
	REQUESTFORQUOTATION_ADD,
	DOWNLOAD_RFQ_BUTTON,
	RFQ_LIST,
	RFQ_LIST_SUCCESS,
	RFQ_LIST_COUNT,
	RFQ_LIST_COUNT_SUCCESS,
	SET_PARAMS,
	FILTER_INPUT_CHANGEVALUE,
	FILTER_SELECT_CHANGEVALUE,
	INPUT_CHANGEVALUE,
	SELECT_CHANGEVALUE,
	RFQ_ROW_DATA,
	RFQ_ROW_DATA_SUCCESS,
	TOGGLE_ITEM_MENU,
	LIST_LAYOUT,
	RF_MODEL_LIST_OPEN,
	RF_MODEL_LIST_CLOSE,
	GENERATE_RFQ_PDF,
	FILTERS_SHOW_RIGHT_SIDEBAR,
	FILTERS_HIDE_RIGHT_SIDEBAR,
	CLEAR_FILTER,
	ADD_VENDORS,
	TOOLTI_OPEN,
	PI_DETAILS_MODEL_OPEN,
	PI_DETAILS_MODEL_CLOSE,
	PI_ROW_DATA_SUCCESS,
	MR_CODE_DETAILS,
	MR_CODE_DETAILS_SUCCESS,
	ADD_VENDORS_MODEL_CLOSE,
	ADD_VENDORS_MODEL_OPEN,
	MR_ITEM_IMAGES,
	MR_ITEM_IMAGES_SUCCESS,
	PI_MR_ITEM_IMAGES_MODEL_CLOSE,
	RFQ_PI_ITEM_CANCEL,
} from "./actionTypes";

const initialState = {
	PIlistItems: [],
	PIlistItemscount: 0,
	allItemsCheked: false,
	PIcheckedItem: [],
	RFQSelectItem: [],
	vendorslist: [],
	vendordata: [],
	allvendorsCheck: false,
	RFQSelectVendors: [],
	downloadRFQButton: false,
	RFQrowlist: [],
	RFQRowListCount: 0,
	rfqListCount: 0,
	RFQrowdata: [],
	addVendors: false,
	Sortvar: {
		code: "REQUEST NO",
		createdon: "CREATED ON",
	},
	SortPIVar: {
		purchaseindent: "Indent Number",
		date: "Date Required",
	},
	params: {
		rfqstatus: [0],
		no_of_pages: 0,
		page_size: 20,
		page: 1,
		search: "",
		currentSort: "code",
		picurrentSort: "purchaseindent",
		sortOrder: "-",
		start_date: "",
		end_date: "",
	},
	layout: "list",
	error: "Sorry! No Data Found.",
	RFlistModel: false,
	showFilterRightSidebar: false,
	rfqID: 0,
	PIRowDetails: {},
	PIDetailsModel: false,
	addVendorsModel: false,
	dataLoading: false,
	vendorsCount: 0,
	AddVendorRFQId: 0,
	PIMRItemImages: [],
	PIMRItemImagesModel: false,
};

const requestforquotation = (state = initialState, action) => {
	switch (action.type) {
		//>>>>>>>>>>>>>>>>>>>>>>>>>>
		case PURCHASE_INDENTS_LIST:
			state = {
				...state,
				loading: true,
			};
			break;
		case PURCHASE_INDENTS_LIST_SUCCESS:
			var noofpages = Math.ceil(
				action.payload.count / state.params.page_size
			);
			var RFQSelectItem_ids = [].concat.apply(
				[],
				state.RFQSelectItem.map((item) => {
					return item.rfqipiis.map((piitem) => {
						return piitem.piitem.id;
					});
				})
			);
			var PIlistItems = action.payload.results.filter((p) => {
				p.itemcheck = false;
				return RFQSelectItem_ids.indexOf(p.id) === -1;
			});
			// var PIlistItems = action.payload.results.map((i) => {
			//   if (RFQSelectItem_ids.indexOf(i.id) > -1) {
			//     i.itemcheck = true;
			//   } else {
			//     i.itemcheck = false;
			//   }
			//   return i;
			// });
			state = {
				...state,
				PIlistItems: PIlistItems,
				PIlistItemscount: action.payload.count,
				params: {
					...state.params,
					no_of_pages: noofpages,
				},
				loading: false,
			};
			break;
		case ALL_PURCHASE_INDENTS_LIST_CHECKED:
			var PIlistItems1 = [];
			if (action.payload.checked === true) {
				PIlistItems1 = state.PIlistItems.map((item) => {
					item.itemcheck = true;
					return item;
				});
				state.PIcheckedItem = PIlistItems1;
				state.allItemsCheked = true;
			} else {
				PIlistItems1 = state.PIlistItems.map((item) => {
					item.itemcheck = false;
					return item;
				});
				state.PIcheckedItem = PIlistItems1;
				state.allItemsCheked = false;
			}
			state = {
				...state,
				PIlistItems: PIlistItems1,
			};

			break;
		case PURCHASE_INDENTS_LIST_CHECKED:
			if (action.payload.checked === true) {
				state.PIlistItems[action.payload.index].itemcheck = true;
				state = {
					...state,
					PIcheckedItem: [
						...state.PIcheckedItem,
						{ ...action.payload.item },
					],

					loading: false,
				};
			} else {
				state.PIlistItems[action.payload.index].itemcheck = false;
				var pIcheckedItem = state.PIcheckedItem.filter((p) => {
					return p.id !== action.payload.item.id;
				});

				state = {
					...state,

					PIcheckedItem: pIcheckedItem,
				};
			}

			if (state.PIlistItems.length === state.PIcheckedItem.length) {
				state.allItemsCheked = true;
			} else {
				state.allItemsCheked = false;
			}

			break;
		case RFQ_SELECTED_ITEM:
			if (action.payload.checked === true) {
				// action.payload.item..map().id
				// PISelectItem
				// var PIFilterItem = state.PISelectItem.filter((p) => {
				//   return p.product.id == action.payload.item.product.id;
				// });
				// if (PIFilterItem.length > 0) {
				//   var PISelectItem = state.PISelectItem.map((product) => {
				//     if (product.product.id == action.payload.item.product.id) {
				//       product.qty += action.payload.item.qty;
				//       product.piimris = [
				//         ...product.piimris,
				//         {
				//           qty: action.payload.item.qty,
				//           unit: {
				//             id: action.payload.item.unit.id,
				//             name: action.payload.item.unit.name,
				//           },
				//           mritem: {
				//             id: action.payload.item.id,
				//             availableqty: 0,
				//           },
				//         },
				//       ];
				//     }
				//     return product;
				//   });

				//   state = {
				//     ...state,
				//     PISelectItem: PISelectItem,
				//   };
				// } else {
				state = {
					...state,
					vendorslist: [],
					RFQSelectVendors: [],
					PIcheckedItem: [],
					allItemsCheked: false,
					RFQSelectItem: [
						...state.RFQSelectItem,
						{
							tooltipOpen: false,
							product: action.payload.item.product,
							qty: action.payload.item.qty,
							date: action.payload.item.date,
							make: action.payload.item.make,
							description: action.payload.item.description,
							unit: {
								id: action.payload.item.unit.id,
								name: action.payload.item.unit.name,
							},
							RFQ_id: action.payload.item.id,
							PI_Id: action.payload.item.purchaseindent_id,
							PI_Code: action.payload.item.purchaseindentcode,
							purchaseindent_description:
								action.payload.item.purchaseindent_description,

							rfqipiis: [
								{
									qty: action.payload.item.qty,
									unit: {
										id: action.payload.item.unit.id,
										name: action.payload.item.unit.name,
									},
									piitem: {
										product: action.payload.item.product,
										qty: action.payload.item.qty,
										unit: {
											id: action.payload.item.unit.id,
											name: action.payload.item.unit.name,
										},
										id: action.payload.item.id,
									},
								},
							],
						},
					],
				};
				// }
			} else {
				var RFQFilterItem = state.RFQSelectItem.filter((p) => {
					return p.RFQ_id !== action.payload.item.RFQ_id;
				});
				state = {
					...state,
					allItemsCheked: false,
					RFQSelectVendors: [],
					RFQSelectItem: RFQFilterItem,
				};
			}
			break;
		case RFQ_SELECTED_ALL_VENDORS:
			var SelectedVendors = [];
			if (action.payload.checked === true) {
				SelectedVendors = state.vendorslist.map((vend) => {
					vend.vendorsCheck = true;
					return vend;
				});
				state.allvendorsCheck = true;
				state.RFQSelectVendors = SelectedVendors;
			} else {
				SelectedVendors = state.vendorslist.map((vend) => {
					vend.vendorsCheck = false;
					return vend;
				});
				state.allvendorsCheck = false;
				state.RFQSelectVendors = [];
			}
			state = {
				...state,
				vendorslist: SelectedVendors,
			};
			break;
		case RFQ_SELECTED_VENDORS:
			if (action.payload.checked === true) {
				state.vendorslist[action.payload.index].vendorsCheck = true;
				state = {
					...state,
					RFQSelectVendors: [
						...state.RFQSelectVendors,
						action.payload.vend,
					],
				};
			} else {
				state.vendorslist[action.payload.index].vendorsCheck = false;
				var RFQSelectVendors = state.RFQSelectVendors.filter((p) => {
					return p.id !== action.payload.vend.id;
				});
				state = {
					...state,
					RFQSelectVendors: RFQSelectVendors,
				};
			}
			if (state.RFQSelectVendors.length === state.vendorslist.length) {
				state.allvendorsCheck = true;
			} else {
				state.allvendorsCheck = false;
			}
			break;
		case CELAR_VENDORS:
			state = {
				...state,
				RFQSelectVendors: [],
				allvendorsCheck: false,
			};
			break;
		case VENDORS_LIST:
			if (action.payload.clearVendlist === true) {
				state.vendorslist = [];
			}
			state = {
				...state,
				dataLoading: true,
				addVendors: action.payload.addVendors,

				//
			};
			break;
		case VENDORS_LIST_SUCCESS:
			var vendorslist = [];
			var Vendorsnoofpages = Math.ceil(
				action.payload.count / state.params.page_size
			);

			if (state.addVendors) {
				var RFQSelectedVendorsIds = state.RFQrowdata.rfqvendors.map(
					(vend) => {
						return vend.vendor.id;
					}
				);
				var vendor_list = action.payload.results.filter((i) => {
					return RFQSelectedVendorsIds.indexOf(i.id) === -1;
				});

				vendorslist = vendor_list.map((vend) => {
					vend.vendorsCheck = false;
					return vend;
				});
			} else {
				var RFQSelectVendorsIds = state.RFQSelectVendors.map((vend) => {
					return vend.id;
				});

				// var vendorslist = action.payload.data.map((i) => {
				vendorslist = action.payload.results.map((i) => {
					if (RFQSelectVendorsIds.indexOf(i.id) > -1) {
						i.vendorsCheck = true;
					} else {
						i.vendorsCheck = false;
					}
					return i;
				});
			}
			state = {
				...state,
				vendorslist: [...state.vendorslist, ...vendorslist],
				vendorsCount: action.payload.count,
				dataLoading: false,
				params: {
					...state.params,
					no_of_pages: Vendorsnoofpages,
				},
			};
			break;
		case ADD_VENDORS_MODEL_OPEN:
			state = {
				...state,
				AddVendorRFQId: action.payload.RFQId,
				addVendorsModel: true,
				vendorslist: [],
				loading: false,
			};
			break;
		case ADD_VENDORS_MODEL_CLOSE:
			state = {
				...state,
				addVendorsModel: false,
				loading: false,
			};
			break;
		case GET_VENDORS_DATA:
			state = {
				...state,
				loading: true,
			};
			break;
		case VENDORS_DATA_SUCCESS:
			state = {
				...state,
				vendordata: action.payload,
				loading: false,
			};
			break;
		case REQUESTFORQUOTATION_ADD:
			state = {
				...state,
				loading: true,
			};
			break;
		case DOWNLOAD_RFQ_BUTTON:
			state = {
				...state,
				downloadRFQButton: true,
				rfqID: action.payload.RFQId,
				loading: false,
			};
			break;
		case RFQ_LIST:
			state = {
				...state,
				loading: true,
				filterdata: {},
			};
			break;
		case RFQ_LIST_SUCCESS:
			noofpages = Math.ceil(
				action.payload.count / state.params.page_size
			);
			state = {
				...state,
				RFQrowlist: action.payload.results,
				RFQRowListCount: action.payload.count,
				params: {
					...state.params,
					no_of_pages: noofpages,
				},
				loading: false,
			};
			break;
		case RFQ_LIST_COUNT:
			state = {
				...state,
				loading: true,
			};
			break;
		case RFQ_LIST_COUNT_SUCCESS:
			state = {
				...state,
				rfqListCount: action.payload,
				loading: false,
			};
			break;
		case TOGGLE_ITEM_MENU:
			var RFQrowlist = state.RFQrowlist?.map((i) => {
				if (i.id === action.payload) {
					i.actionMenu = !i.actionMenu;
				} else {
					i.actionMenu = false;
				}
				return i;
			});

			state = {
				...state,
				RFQrowlist: RFQrowlist,
			};
			break;
		case INPUT_CHANGEVALUE:
			state = {
				...state,
				PIRowData: {
					...state.PIRowData,
					[action.payload.key]: action.payload.value,
				},
			};
			break;
		case SELECT_CHANGEVALUE:
			state = {
				...state,
				PIRowData: {
					...state.PIRowData,
					[action.payload.key]: action.payload.label,
					[action.payload.key2]: action.payload.value,
				},
			};
			break;
		case SET_PARAMS:
			state = {
				...state,
				params: action.payload,
			};
			break;
		case FILTER_INPUT_CHANGEVALUE:
			state = {
				...state,
				params: {
					...state.params,
					[action.payload.key]: action.payload.value,
				},
			};
			break;
		case FILTER_SELECT_CHANGEVALUE:
			state = {
				...state,
				filterdata: {
					...state.filterdata,
					[action.payload.key]: action.payload.label,
				},
				params: {
					...state.params,
					[action.payload.key2]: action.payload.value,
				},
			};
			break;
		case RFQ_ROW_DATA:
			state = {
				...state,
				loading: true,
				RFQSelectVendors: [],
			};
			break;
		case RFQ_ROW_DATA_SUCCESS:
			state = {
				...state,
				RFQrowdata: action.payload,
				loading: false,
			};
			break;
		case MR_CODE_DETAILS:
			state = {
				...state,
				loading: true,
				rfqItemId: action.payload.ItemId,
			};
			break;
		case MR_CODE_DETAILS_SUCCESS:
			var rfqitems = state.RFQrowdata.rfqitems.map((item, i) => {
				if (item.id === state.rfqItemId) {
					item.mrdata = action.payload;
				}
				return item;
			});
			state = {
				...state,
				RFQrowdata: { ...state.RFQrowdata, rfqitems: rfqitems },
				loading: false,
			};
			break;
		case RF_MODEL_LIST_OPEN:
			state = {
				...state,
				loading: true,
				RFlistModel: true,
			};
			break;
		case RF_MODEL_LIST_CLOSE:
			state = {
				...state,

				RFlistModel: false,
			};
			break;
		case LIST_LAYOUT:
			state = {
				...state,
				layout: action.payload,
				loading: false,
			};
			break;
		case GENERATE_RFQ_PDF:
			state = {
				...state,
				loading: false,
			};
			break;
		case FILTERS_SHOW_RIGHT_SIDEBAR:
			state = {
				...state,
				showFilterRightSidebar: !state.showFilterRightSidebar,
			};
			break;
		case FILTERS_HIDE_RIGHT_SIDEBAR:
			state = {
				...state,

				showFilterRightSidebar: false,
			};
			break;
		case CLEAR_FILTER:
			state = {
				...state,
				filterdata: {},
			};
			break;
		case ADD_VENDORS:
			state = {
				...state,
				loading: true,
			};
			break;
		case TOOLTI_OPEN:
			var tooltiItems = [];
			tooltiItems = state.RFQSelectItem.map((item) => {
				if (item.RFQ_id === action.payload.Item.RFQ_id) {
					item.tooltipOpen = !item.tooltipOpen;
				}
				return item;
			});
			state = {
				...state,
				RFQSelectItem: tooltiItems,
				loading: false,
			};
			break;
		case PI_DETAILS_MODEL_OPEN:
			state = {
				...state,
				loading: true,
				PIDetailsModel: true,
				PIid: action.payload.MRID,
				PIRowDetails: {},
			};
			break;
		case PI_DETAILS_MODEL_CLOSE:
			state = {
				...state,
				PIDetailsModel: false,
			};
			break;
		case PI_ROW_DATA_SUCCESS:
			var PI_approvals = [];
			PI_approvals = action.payload.pi_approvals.filter((approvale) => {
				if (approvale.pistatus === 3) {
					return approvale.approvedby;
				}
				return 0;
			});

			state = {
				...state,
				PIRowDetails: {
					...action.payload,
					userDeptApprovedby: PI_approvals,
				},
				loading: false,
			};
			break;
		case MR_ITEM_IMAGES:
			state = {
				...state,
				loading: true,
			};
			break;
		case MR_ITEM_IMAGES_SUCCESS:
			state = {
				...state,
				PIMRItemImages: action.payload,
				loading: false,
				PIMRItemImagesModel: true,
			};
			break;
		case PI_MR_ITEM_IMAGES_MODEL_CLOSE:
			state = {
				...state,
				PIMRItemImagesModel: false,
			};
			break;

		case RFQ_PI_ITEM_CANCEL:
			state = {
				...state,
				loading: true,
			};
			break;
		default:
			state = { ...state };
			break;
	}

	return state;
};
export default requestforquotation;
